import { createRouter, createWebHistory } from 'vue-router'

const ACCOUNT_SEGMENT = '/store/account'

/**
 * The account app is served beneath the funnel's product-list step, e.g.
 * /product-list/store/account/profile. vue-router only strips a base the URL
 * actually starts with, so a fixed '/store/account' leaves the whole path
 * unmatched: the catch-all below then redirects and drops any deep-link query
 * (?editAddress=), and every RouterLink rewrites the URL without the step
 * prefix, which 404s at the edge on refresh.
 */
export const resolveRouterBase = (pathname = typeof window === 'undefined' ? '' : window.location.pathname): string => {
  const index = pathname.indexOf(ACCOUNT_SEGMENT)
  return index > 0 ? `${pathname.slice(0, index)}${ACCOUNT_SEGMENT}` : ACCOUNT_SEGMENT
}

const router = createRouter({
  history: createWebHistory(resolveRouterBase()),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../pages/LoginWrapper.vue'),
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('../pages/OrderListPage.vue'),
    },
    {
      path: '/orders/:id',
      name: 'order-detail',
      component: () => import('../pages/OrderDetailPage.vue'),
    },
    {
      path: '/wishlist',
      name: 'wishlist',
      component: () => import('../pages/WishlistingScreen.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../pages/ProfilePage.vue'),
    },
    { path: '/:pathMatch(.*)*', redirect: '/orders' },
  ],
})

export default router
